<template>
  <div class="p-businessCustomerVoice">
    <DBusinessCustomerVoiceSwiper
      :customer-voice-list="customerVoiceList"
      :is-pc="isPC"
    />
    <p class="p-businessCustomerVoice_linkWrap">
      <a
        class="p-businessCustomerVoice-link"
        href="https://coconala.com/magazine/case/"
        target="_blank"
        rel="noopener"
      >
        &gt; すべて見る
      </a>
    </p>
  </div>
</template>

<script>
import DBusinessCustomerVoiceSwiper from './components/DBusinessCustomerVoiceSwiper'
import { mapGetters } from 'vuex'

const CUSTOMER_VOICE_LIST = [
  {
    title: '【あいおいニッセイ同和損害保険】',
    description: '営業ツールのアイデアをスピーディーにコスト1/10で実現！',
    href: 'https://coconala.com/magazine/case/153',
    image: {
      src: '/staticfiles/images/pages/business/lp/customer_04.png',
      alt: 'あいおいニッセイ同和損害保険'
    }
  },
  {
    title: '【株式会社reiniciar】',
    description: '「ロゴ」「HP」「パンフレット」起業に必要な制作物のほとんどをココナラで購入！',
    href: 'https://coconala.com/magazine/case/159',
    image: {
      src: '/staticfiles/images/pages/business/lp/customer_05.jpg',
      alt: '株式会社reiniciar'
    }
  },
  {
    title: '【東急株式会社】',
    description:
      'たった５日で依頼から納品までできたのはココナラだから！2027年まで、渋谷の連絡通路に掲出できるロゴを依頼',
    href: 'https://coconala.com/magazine/case/143',
    image: {
      src: '/staticfiles/images/pages/business/lp/customer_01.png',
      alt: '東急株式会社'
    }
  },
  {
    title: '【住友生命】',
    description:
      '80億円ファンドのロゴを作成　クリエイターと直接のやり取りで、イメージ通りのものができた',
    href: 'https://coconala.com/magazine/case/140',
    image: {
      src: '/staticfiles/images/pages/business/lp/customer_02.png',
      alt: '住友生命'
    }
  },
  {
    title: '【株式会社BLISS】',
    description: 'ココナラで外観パース制作を外注し、業務の効率化を実現！',
    href: 'https://coconala.com/magazine/case/146',
    image: {
      src: '/staticfiles/images/pages/business/lp/customer_06.jpg',
      alt: '株式会社BLISS'
    }
  },
  {
    title: '【清水建設】',
    description:
      '新規事業に必要な、翻訳・海外のリサーチ・ポスター作成　必要な分だけスキルを利用できるココナラの魅力',
    href: 'https://coconala.com/magazine/case/137',
    image: {
      src: '/staticfiles/images/pages/business/lp/customer_03.png',
      alt: '清水建設'
    }
  }
]

export default {
  name: 'DBusinessCustomerVoice',
  components: { DBusinessCustomerVoiceSwiper },
  computed: {
    ...mapGetters('ui', ['isPC']),
    customerVoiceList: () => CUSTOMER_VOICE_LIST
  }
}
</script>

<style lang="scss" scoped>
.p-businessCustomerVoice {
  &-link {
    @include link-effect;
    color: $ds2-color-brand-secondary;
  }
  &_linkWrap {
    margin-bottom: 0;
    font-size: 16px;
    text-align: center;
  }
}
</style>
